<div class="open-banner-container" [ngClass]="[componentDetails?.settings?.class || '', 'is-' + componentDetails?.settings?.type]">
  <div class="open-banner">

    <!-- Card image -->
    <div class="open-banner-image" *ngIf="componentDetails?.settings?.imageUrl">
      <img [src]="componentDetails.settings.imageUrl" />
    </div>

    <!-- Card content -->
    <div class="open-banner-details" [ngClass]="'text-'+(componentDetails?.settings?.align || 'left')">

      <div class="open-banner-copy">
        <h1 class="open-banner-title" *ngIf="componentDetails?.settings?.title" [innerHtml]="componentDetails.settings.title"></h1>

        <div class="open-banner-content" *ngIf="componentDetails?.settings?.content" [innerHtml]="componentDetails.settings.content"></div>
      </div>

      <div class="open-banner-rating" *ngIf="componentDetails?.settings?.socialProof?.enabled" [ngClass]="'rating-'+(componentDetails?.settings?.align || 'left')">
        <open-social-rating [componentDetails]="componentDetails?.settings?.socialProof"></open-social-rating>
      </div>

      <div class="open-banner-policy-detail" *ngIf="componentDetails?.settings?.dataDetail?.content">
        <mat-icon [ngClass]="componentDetails?.settings?.dataDetail?.icon" aria-hidden="false"></mat-icon>
        <span>{{ componentDetails?.settings?.dataDetail?.content }}</span> 
      </div>

    </div>
  </div>
</div>
